// ------------------------------------
// Galeria (Lightbox2)
// ------------------------------------
var galleyLightbox;
function initLightbox() {
  if (!galleyLightbox) {
    if ($('[data-lightbox]').length > 0) {
      const lightboxCfg = {
        navText: ['', ''],
        closeText: '',
        captionPosition: 'outside',
        fileExt: false,
        heightRatio: 0.8,
        captionSelector: 'self',
        captionType: 'data',
        history: false,
        animationSpeed: 100,
      };
      galleyLightbox = new SimpleLightbox('[data-lightbox]', lightboxCfg);
    }
  } else {
    galleyLightbox.refresh();
  }
}
initLightbox();
